import React from 'react';
import styled from 'styled-components';
import { Heart, Github, Linkedin, ArrowUp } from 'lucide-react';
import { personal } from '../data/portfolio';

const Wrap = styled.footer`
  border-top: 1px solid ${({ theme }) => theme.colors.border};
  padding: 40px 24px 30px;
  position: relative;
  z-index: 1;
`;

const Inner = styled.div`
  max-width: ${({ theme }) => theme.layout.maxWidth};
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 20px;
  flex-wrap: wrap;
`;

const Logo = styled.div`
  font-family: ${({ theme }) => theme.fonts.display};
  font-weight: 700;
  font-size: 22px;

  span { color: ${({ theme }) => theme.colors.primarySoft}; }
`;

const Copy = styled.div`
  color: ${({ theme }) => theme.colors.textMuted};
  font-size: 13px;
  display: inline-flex;
  align-items: center;
  gap: 6px;

  svg { color: ${({ theme }) => theme.colors.primarySoft}; }
`;

const Side = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`;

const IconLink = styled.a`
  width: 40px;
  height: 40px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 12px;
  background: ${({ theme }) => theme.colors.surface};
  border: 1px solid ${({ theme }) => theme.colors.border};
  color: ${({ theme }) => theme.colors.textDim};
  cursor: pointer;
  transition: color 200ms ease, border-color 200ms ease, transform 200ms ease;

  &:hover {
    color: ${({ theme }) => theme.colors.primarySoft};
    border-color: ${({ theme }) => theme.colors.primarySoft};
    transform: translateY(-2px);
  }
`;

export default function Footer() {
  const scrollTop = () => window.scrollTo({ top: 0, behavior: 'smooth' });
  return (
    <Wrap>
      <Inner>
        <Logo>Darryl<span>.</span></Logo>
        <Copy>
          Built by myself using ReactJS · © 2019
        </Copy>
        <Side>
          <IconLink href={personal.socials.linkedin} target="_blank" rel="noreferrer" aria-label="LinkedIn"><Linkedin size={18} /></IconLink>
          <IconLink href={personal.socials.github} target="_blank" rel="noreferrer" aria-label="GitHub"><Github size={18} /></IconLink>
          <IconLink as="button" onClick={scrollTop} aria-label="Back to top"><ArrowUp size={18} /></IconLink>
        </Side>
      </Inner>
    </Wrap>
  );
}
